<template>
  <authorization permissionKey="configuration_service" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Serviços
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs v-model="tab" background-color="transparent" color="secondary">
            <v-tab v-for="(value, key) in medicalRequestTypes" :key="key">
              {{ value }}
            </v-tab>
            <v-tab>
              Facilitadores
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(value, key) in medicalRequestTypes" :key="key">
              <MedicalRequestList
                :medicalRequestItems="medicalRequestItems"
                :medicalRequestType="key"
                :refreshList="refreshList"
              />
            </v-tab-item>
            <v-tab-item>
              <MedicalRequestItemFacilitators />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
  import MedicalRequestList from "@/components/config/medical_request/list.vue";
  import MedicalRequestItemFacilitators from "@/components/config/medical_request/item_facilitators/index.vue";

  export default {
    name: "ServicesConfig",
    components: {
      MedicalRequestList,
      MedicalRequestItemFacilitators,
    },
    data() {
      return {
        tab: null,
        medicalRequestTypes: {
          exam: "Exames",
          treatment: "Tratamentos",
          surgery: "Cirurgias"
        },
      };
    },
    apollo: {
      medicalRequestItems: {
        query: require("@/graphql/medical_request/medical_request_items.gql"),
        pollInterval: 20000,
      },
    },
    methods: {
      refreshList() {
        this.$apollo.queries.medicalRequestItems.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
